// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Modern light theme - soft blue-gray tones */
  --c-bkg-body: #f0f4f8;
  --c-bkg-card: #ffffff;
  --c-bkg-sidebar: #ffffff;
  --c-bkg-hover: #f8fafc;

  --c-text-base: #1e293b;
  --c-text-muted: #64748b;
  --c-text-light: #94a3b8;

  /* Icon colors - modern muted tones */
  --c-icon: #64748b;
  --c-icon-hover: #6366f1;
  --c-icon-active: #4f46e5;
  --c-icon-muted: #94a3b8;

  /* Modern border with subtle blue tint */
  --c-border: #e2e8f0;
  --c-border-light: #f1f5f9;

  /* Refined brand colors - modern indigo */
  --c-primary: #6366f1;
  --c-primary-light: #818cf8;
  --c-primary-dark: #4f46e5;
  --c-success: #10b981;
  --c-warning: #f59e0b;
  --c-danger: #ef4444;
  --c-info: #0ea5e9;

  /* Modern shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.07), 0 2px 4px -2px rgb(0 0 0 / 0.05);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.05);
  --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.04), 0 1px 2px -1px rgb(0 0 0 / 0.04);

  /* Border radius */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 20px;

  /* Vector map colors */
  --vmap-bg-color: #ffffff;
  --vmap-border-color: #ffffff;
  --vmap-region-color: #e4ecef;
  --vmap-marker-fill: #ffffff;
  --vmap-marker-stroke: #000000;
  --vmap-hover-color: #ffffff;
  --vmap-selected-color: #c9dfaf;
  --vmap-scale-start: #03a9f3;
  --vmap-scale-end: #02a7f1;
  --vmap-scale-light: #b6d6ff;
  --vmap-scale-dark: #005ace;

  /* Skycons */
  --skycons-color: #ff6849;

  /* Sparkline colors - more vibrant */
  --sparkline-success: #10b981;
  --sparkline-purple: #8b5cf6;
  --sparkline-info: #0ea5e9;
  --sparkline-danger: #ef4444;
  --sparkline-light: #a5b4fc;

  /* Loader */
  --loader-bg: #ffffff;
  --spinner-bg: #333333;

  /* Google Maps */
  --gmap-landscape-hue: #FFBB00;
  --gmap-highway-hue: #FFC200;
  --gmap-road-hue: #FF0300;
  --gmap-water-hue: #0078FF;
  --gmap-poi-hue: #00FF6A;
}

[data-theme="dark"] {
  /* Modern dark theme - refined dark slate */
  --c-bkg-body: #0f172a;
  --c-bkg-card: #1e293b;
  --c-bkg-sidebar: #1e293b;
  --c-bkg-hover: #334155;

  --c-text-base: #f1f5f9;
  --c-text-muted: #94a3b8;
  --c-text-light: #64748b;

  /* Icon colors - dark theme */
  --c-icon: #94a3b8;
  --c-icon-hover: #a5b4fc;
  --c-icon-active: #818cf8;
  --c-icon-muted: #64748b;

  --c-border: #334155;
  --c-border-light: #475569;

  /* Same primary for consistency, adjusted for dark */
  --c-primary: #818cf8;
  --c-primary-light: #a5b4fc;
  --c-primary-dark: #6366f1;
  --c-success: #34d399;
  --c-warning: #fbbf24;
  --c-danger: #f87171;
  --c-info: #38bdf8;

  /* Dark mode shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.3);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.4), 0 2px 4px -2px rgb(0 0 0 / 0.3);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.5), 0 4px 6px -4px rgb(0 0 0 / 0.4);
  --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.2), 0 1px 2px -1px rgb(0 0 0 / 0.2);

  /* Vector map colors - dark theme */
  --vmap-bg-color: #1e293b;
  --vmap-border-color: #334155;
  --vmap-region-color: #334155;
  --vmap-marker-fill: #f1f5f9;
  --vmap-marker-stroke: #94a3b8;
  --vmap-hover-color: #0f172a;
  --vmap-selected-color: #475569;
  --vmap-scale-start: #6366f1;
  --vmap-scale-end: #4f46e5;
  --vmap-scale-light: #4338ca;
  --vmap-scale-dark: #a5b4fc;

  /* Skycons - dark theme */
  --skycons-color: #fb923c;

  /* Sparkline colors - dark theme */
  --sparkline-success: #34d399;
  --sparkline-purple: #a78bfa;
  --sparkline-info: #38bdf8;
  --sparkline-danger: #f87171;
  --sparkline-light: #a5b4fc;

  /* Loader - dark theme */
  --loader-bg: #0f172a;
  --spinner-bg: #f1f5f9;

  /* Google Maps - dark theme */
  --gmap-landscape-hue: #D4AC0D;
  --gmap-highway-hue: #E6AC00;
  --gmap-road-hue: #CC2900;
  --gmap-water-hue: #1B4F72;
  --gmap-poi-hue: #148F77;
}
`, "",{"version":3,"sources":["webpack://./../assets/styles/utils/theme.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;;EAEtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;;EAEvB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;;EAEzB,yCAAyC;EACzC,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;;EAEjB,mBAAmB;EACnB,0CAA0C;EAC1C,+EAA+E;EAC/E,iFAAiF;EACjF,8EAA8E;;EAE9E,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,YAAY;EACZ,wBAAwB;;EAExB,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,WAAW;EACX,oBAAoB;EACpB,qBAAqB;;EAErB,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;;EAEtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;;EAEvB,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;;EAEvB,mBAAmB;EACnB,yBAAyB;;EAEzB,oDAAoD;EACpD,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;;EAEjB,sBAAsB;EACtB,yCAAyC;EACzC,6EAA6E;EAC7E,+EAA+E;EAC/E,4EAA4E;;EAE5E,mCAAmC;EACnC,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,yBAAyB;EACzB,wBAAwB;;EAExB,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;;EAErB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[":root {\n  /* Modern light theme - soft blue-gray tones */\n  --c-bkg-body: #f0f4f8;\n  --c-bkg-card: #ffffff;\n  --c-bkg-sidebar: #ffffff;\n  --c-bkg-hover: #f8fafc;\n\n  --c-text-base: #1e293b;\n  --c-text-muted: #64748b;\n  --c-text-light: #94a3b8;\n\n  /* Icon colors - modern muted tones */\n  --c-icon: #64748b;\n  --c-icon-hover: #6366f1;\n  --c-icon-active: #4f46e5;\n  --c-icon-muted: #94a3b8;\n\n  /* Modern border with subtle blue tint */\n  --c-border: #e2e8f0;\n  --c-border-light: #f1f5f9;\n\n  /* Refined brand colors - modern indigo */\n  --c-primary: #6366f1;\n  --c-primary-light: #818cf8;\n  --c-primary-dark: #4f46e5;\n  --c-success: #10b981;\n  --c-warning: #f59e0b;\n  --c-danger: #ef4444;\n  --c-info: #0ea5e9;\n\n  /* Modern shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.07), 0 2px 4px -2px rgb(0 0 0 / 0.05);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.08), 0 4px 6px -4px rgb(0 0 0 / 0.05);\n  --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.04), 0 1px 2px -1px rgb(0 0 0 / 0.04);\n\n  /* Border radius */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 20px;\n\n  /* Vector map colors */\n  --vmap-bg-color: #ffffff;\n  --vmap-border-color: #ffffff;\n  --vmap-region-color: #e4ecef;\n  --vmap-marker-fill: #ffffff;\n  --vmap-marker-stroke: #000000;\n  --vmap-hover-color: #ffffff;\n  --vmap-selected-color: #c9dfaf;\n  --vmap-scale-start: #03a9f3;\n  --vmap-scale-end: #02a7f1;\n  --vmap-scale-light: #b6d6ff;\n  --vmap-scale-dark: #005ace;\n\n  /* Skycons */\n  --skycons-color: #ff6849;\n\n  /* Sparkline colors - more vibrant */\n  --sparkline-success: #10b981;\n  --sparkline-purple: #8b5cf6;\n  --sparkline-info: #0ea5e9;\n  --sparkline-danger: #ef4444;\n  --sparkline-light: #a5b4fc;\n\n  /* Loader */\n  --loader-bg: #ffffff;\n  --spinner-bg: #333333;\n\n  /* Google Maps */\n  --gmap-landscape-hue: #FFBB00;\n  --gmap-highway-hue: #FFC200;\n  --gmap-road-hue: #FF0300;\n  --gmap-water-hue: #0078FF;\n  --gmap-poi-hue: #00FF6A;\n}\n\n[data-theme=\"dark\"] {\n  /* Modern dark theme - refined dark slate */\n  --c-bkg-body: #0f172a;\n  --c-bkg-card: #1e293b;\n  --c-bkg-sidebar: #1e293b;\n  --c-bkg-hover: #334155;\n\n  --c-text-base: #f1f5f9;\n  --c-text-muted: #94a3b8;\n  --c-text-light: #64748b;\n\n  /* Icon colors - dark theme */\n  --c-icon: #94a3b8;\n  --c-icon-hover: #a5b4fc;\n  --c-icon-active: #818cf8;\n  --c-icon-muted: #64748b;\n\n  --c-border: #334155;\n  --c-border-light: #475569;\n\n  /* Same primary for consistency, adjusted for dark */\n  --c-primary: #818cf8;\n  --c-primary-light: #a5b4fc;\n  --c-primary-dark: #6366f1;\n  --c-success: #34d399;\n  --c-warning: #fbbf24;\n  --c-danger: #f87171;\n  --c-info: #38bdf8;\n\n  /* Dark mode shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.3);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.4), 0 2px 4px -2px rgb(0 0 0 / 0.3);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.5), 0 4px 6px -4px rgb(0 0 0 / 0.4);\n  --shadow-card: 0 1px 3px 0 rgb(0 0 0 / 0.2), 0 1px 2px -1px rgb(0 0 0 / 0.2);\n\n  /* Vector map colors - dark theme */\n  --vmap-bg-color: #1e293b;\n  --vmap-border-color: #334155;\n  --vmap-region-color: #334155;\n  --vmap-marker-fill: #f1f5f9;\n  --vmap-marker-stroke: #94a3b8;\n  --vmap-hover-color: #0f172a;\n  --vmap-selected-color: #475569;\n  --vmap-scale-start: #6366f1;\n  --vmap-scale-end: #4f46e5;\n  --vmap-scale-light: #4338ca;\n  --vmap-scale-dark: #a5b4fc;\n\n  /* Skycons - dark theme */\n  --skycons-color: #fb923c;\n\n  /* Sparkline colors - dark theme */\n  --sparkline-success: #34d399;\n  --sparkline-purple: #a78bfa;\n  --sparkline-info: #38bdf8;\n  --sparkline-danger: #f87171;\n  --sparkline-light: #a5b4fc;\n\n  /* Loader - dark theme */\n  --loader-bg: #0f172a;\n  --spinner-bg: #f1f5f9;\n\n  /* Google Maps - dark theme */\n  --gmap-landscape-hue: #D4AC0D;\n  --gmap-highway-hue: #E6AC00;\n  --gmap-road-hue: #CC2900;\n  --gmap-water-hue: #1B4F72;\n  --gmap-poi-hue: #148F77;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
